/* eslint-disable @typescript-eslint/no-explicit-any */
/* Basic Information — shared by all structure types (Structure Name +
   Description). The structure type itself is chosen in the step-1 picker. */
import React from "react";
import Input from "components/Input";
import { SectionCard } from "./_controls";

const BasicInfoSection = () => (
  <SectionCard title="Basic Information" subtitle="Identify this salary structure.">
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <Input compact name="structureName" label="Structure Name" required />
      <Input compact name="description" label="Description" />
    </div>
  </SectionCard>
);

export default BasicInfoSection;
